/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import {
  JobColorSelectionRestService,
  JobListFilterDto,
  JobRestService,
} from '@gh/builder-shared-data';
import { getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { JobListItem } from './job.model';
import { FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class JobCsListBusinessService implements InitViewService {
  constructor(private jobRest: JobRestService,
              private jobCsRest: JobColorSelectionRestService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('jobCsList'),
      filter:  this.filterService.get(FilterNames.jobCsList),
      createCS: getRouteQueryParam(route, 'createCS'),
      message: getRouteQueryParam(route, 'message'),
    };
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItem> {
    return this.jobCsRest.findAllAsDataSource(filter);
  }
}
